import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import EmployeePickerField from "../../../../../common/selectComponents/EmployeePicker";
import { Button } from "../../../../../common/APICommon";

export function MaintenanceApproverListTab({
  isViewOnly,
  levels,
  setLevels,
  count,
  errorState,
  showGeneralMessage
}) {

  const addSlot = (idx) => {
    const next = [...levels];
    next[idx] = [...next[idx], { approverId: "", fullName: "" }];
    setLevels(next);
  };

  const removeSlot = (lIdx, sIdx) => {
    const next = [...levels];
    next[lIdx] = next[lIdx].filter((_, i) => i !== sIdx);
    setLevels(next);
  };

  const handleSelect = (lIdx, sIdx, emp) => {
    const next = [...levels];
    next[lIdx] = next[lIdx].map((s, i) =>
      i === sIdx ? { approverId: emp.id, fullName: emp.fullName } : s
    );
    setLevels(next);
  };

  return (
    <div className="space-y-6">
      {/* Duplicate Approver Warning */}
      {errorState?.duplicateApprover && (
        <div className="flex items-center space-x-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-700">
          <WarningIcon fontSize="small" />
          <span>
            <strong>Duplicate detected:</strong> {errorState.duplicateApproverName} is already assigned to this hierarchy.
          </span>
        </div>
      )}

      {Array.from({ length: count }).map((_, lIdx) => (
        <div key={lIdx} className="space-y-2">
          <div
            className={`overflow-hidden rounded-xl border shadow-sm ${errorState?.levels?.[lIdx] ? "border-red-300 bg-red-50/20" : "border-gray-200 bg-gray-50/30"
              }`}
          >
            {/* Level Header */}
            <div
              className={`flex items-center justify-between border-b px-4 py-2 ${errorState?.levels?.[lIdx] ? "border-red-200 bg-red-100/50" : "border-gray-200 bg-gray-100/80"
                }`}
            >
              <span className={`text-sm font-bold ${errorState?.levels?.[lIdx] ? "text-red-700" : "text-gray-600"}`}>
                Level {lIdx + 1} Approvers
              </span>

              {!isViewOnly && (
                <Button
                  icon={<AddIcon fontSize="small" />}
                  className="text-xs text-blue-500 hover:text-blue-600 border border-blue-300 hover:border-blue-500 bg-blue-50 hover:bg-blue-100 cursor-pointer"
                  onClick={() => addSlot(lIdx)}
                  name="Add"
                />
              )}
            </div>

            {/* Slots Area */}
            <div className="space-y-3 p-4">
              {levels[lIdx]?.map((slot, sIdx) => (
                <div key={sIdx} className="flex items-center space-x-2">
                  <div className="flex-1">
                    <EmployeePickerField
                      employeePersonalInformationId={slot.approverId}
                      displayValue={slot.fullName}
                      onSelect={(emp) => handleSelect(lIdx, sIdx, emp)}
                      onClear={() => handleSelect(lIdx, sIdx, { id: "", fullName: "" })}
                      compact={true}
                      disabled={isViewOnly}
                    />
                  </div>

                  {!isViewOnly && levels[lIdx].length > 1 && (
                    <button
                      onClick={() => removeSlot(lIdx, sIdx)}
                      className="cursor-pointer border-none bg-transparent text-gray-400 hover:text-red-500"
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Individual Level Error Message */}
          {errorState?.levels?.[lIdx] && (
            <p className="ml-1 text-xs font-medium text-red-500">
              Please assign at least one approver for Level {lIdx + 1}.
            </p>
          )}
        </div>
      ))}
    </div>
  );
}